export enum LocalStorage {
  UserInfo = 'UserInfo',
  CurrentLanguage = 'CurrentLanguage',
  UserLoggedIn = 'UserLoggedIn',
  IsRememberMe = 'IsRememberMe',
  FilterLookups = 'FilterLookups',
  FaceVerified = 'FaceVerified',
  AxonifyIframeOpen = 'AxonifyIframeOpen'
}

export enum Language {
  English = 'en',
  Arabic = 'ar'
}

export enum OTP {
  Login = '2',
  Register = '1',
  ForgotPassword = '3'
}

export enum UserType {
  Educare = 'EC',
  Physician = 'PR'
}

export enum SortOrder {
  Ascending = 'asc',
  Descending = 'desc'
}
export enum AdvanceFilterType {
  Sort = 'sort',
  Title = 'title',
  Gender = 'gender',
  Nationality = 'nationality',
  LangaugeSpoken = 'langauge_spoken',
  Specialty = 'specialty',
  Specialization = 'specialization',
  ClinicalSkills = 'clinical_skills',
  CriticalSkill = 'critical_skill',
  AdditionalSkill = 'additional_skill',
  Memberships = 'member_ships',
  EducationLevel = 'education_level',
  Awards = 'awards',
  ProfileStatus = 'profile_status',
  Facility = 'medical_facility',
  Location = 'location',
  Category = 'category'
}

export enum SnackBar {
  Success = 'success',
  Error = 'error'
}

export enum AxonifyStatus {
  Approved = 'APPROVE',
  Rejected = 'REJECT',
  Pending = 'PENDING'
}

export enum TableAction {
  Edit = 'edit',
  View = 'view',
  Delete = 'delete',
  Download = 'download',
  ShowImage = 'showImage'
}

export enum TableActionType {
  IconButton = 'icon-button',
  Checkbox = 'checkbox'
}

export enum PortalType {
  User = 'user',
  Admin = 'admin'
}
export enum IconSizeClass {
  Small = 'fs-3',
  Large = 'fs-1'
}

export enum Status {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Deleted = 'DELETED',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED',
  Draft = 'DRAFT',
  SystemApproved = 'SYSTEM_APPROVED'
}

export enum StatusAr {
  Pending = 'قيد الانتظار',
  Approved = 'موافق عليه',
  Rejected = 'مرفوض',
  Deleted = 'محذوف',
  Published = 'منشور',
  Scheduled = 'مجدول',
  Draft = 'مسودة'
}

export enum iconStatus {
  true = '1',
  false = '0'
}

export enum CmeCategory {
  InPerson = '1',
  Virtual = '2'
}

export enum UserCategory {
  Physician = 'PHYSICIAN',
  Nurse = 'NURSE',
  AlliedHealth = 'ALLIED_HEALTH',
  HospitalManagement = 'HOSPITAL_MANAGEMENT',
  GeneralManagement = 'GENERAL_MANAGEMENT',
  MidWife = 'MID_WIFE'
}

export enum rsvp_response {
  yes = 'YES',
  no = 'NO'
}

export enum TargetAudience {
  All = 'ALL',
  Entities = 'ENTITIES',
  Users = 'USERS',
  External = 'EXTERNAL',
  Mixed = 'MIXED'
}
